module.exports = require("core-js/library/fn/object/get-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/object/get-prototype-of.js
// module id = 718
// module chunks = 101